<div [ngClass]="data.cssClasses.titleElement">{{data.texts.selectionTitle | localize}} <a [ngClass]="data.cssClasses.resetMetadataIconElement" (click)="data.resetMetadata()"></a></div>

<div [ngClass]="data.cssClasses.columnsContainer" cdkDropList (cdkDropListDropped)="drop($event)">
    @for(column of data.metadata().columns; track column)
    {
        <div cdkDrag [cdkDragDisabled]="data.options?.dragDisabled" [ngClass]="data.cssClasses.columnElement">
            <label>
                <span [ngClass]="data.cssClasses.dragIndicationElement"></span>
                <input type="checkbox" [checked]="column.visible" (change)="toggleVisibility(column, $event)">
                <span>{{column.title}}</span>
            </label>
        </div>
    }
</div>